import { ArrowBackRoundedIcon, Button, Flex, PageHeader, Text } from '@shared/components';

export interface QContentCreateHeaderProps {
  title: string;
  courseID: string;
  qbsName: string;
  navigateBackLabel?: string;
  onBack: () => void;
}

export default function QContentCreateHeader(props: Readonly<QContentCreateHeaderProps>) {
  const { title, courseID, qbsName, navigateBackLabel = 'Back to Question List', onBack } = props;

  return (
    <PageHeader
      title={title}
      subtitleSection={
        <Flex
          sx={(theme) => ({
            gap: theme.spacing(2),
          })}
        >
          <Text variant='body2' color='text.secondary'>
            CourseID: {courseID}
          </Text>
          <Text variant='body2' color='text.secondary'>
            {qbsName}
          </Text>
        </Flex>
      }
      linkAdornment={
        <Button
          variant='text'
          startIcon={<ArrowBackRoundedIcon />}
          onClick={onBack}
          sx={{
            p: (theme) => theme.spacing(0),
            minWidth: 'auto',
            height: 'auto',
          }}
        >
          {navigateBackLabel}
        </Button>
      }
    />
  );
}
